/**
 * Created by XuQiang on 2017/5/23.
 */
import React from 'react';
import { CHINESE, CHINESE_HK, ENGLISH } from '../../utils/constants';

const virsical_LOGO = require('../../assets/virsical-LOGO.png');

export default ({ dispatch, flag, menuData, locale }) => {
  let isChinese = locale === 'zh_CN';
  const {domainI18nLogoZH,domainI18nLogoEN,sysNameEN,sysNameZH} = menuData;
  let logImgUrl = '';
  let sysNameStr = '';
  if (isChinese && domainI18nLogoZH) {
    logImgUrl = domainI18nLogoZH;
  } else {
    if (domainI18nLogoEN) {
      logImgUrl = domainI18nLogoEN;
    } else if (domainI18nLogoZH) {
      logImgUrl = domainI18nLogoZH;
    }
  }
  
  if(isChinese && sysNameZH){
    sysNameStr = sysNameZH;
  }else{
    if(sysNameEN){
      sysNameStr = sysNameEN;
    }else if(sysNameZH){
      sysNameStr =   sysNameZH;
    }
  }

  return (
    <div className="main-title">
      {/*<div*/}
      {/*  className="title-logo"*/}
      {/*  onDoubleClick={() =>*/}
      {/*    dispatch({ type: 'login/setDivType', divType: OPEN_SIGN })*/}
      {/*  }*/}
      {/*>*/}
      {/*  <span className="virsical">*/}
      {/*    <img src={logImgUrl || virsical_LOGO} />*/}
      {/*  </span>*/}
      {/*  <span className="reserve">*/}
      {/*    /!*<FormattedMessage id="index_reservation_platform" />*!/*/}
      {/*    {sysNameStr}*/}
      {/*  </span>*/}
      {/*</div>*/}
      <ul className="title-nav">
        {/*{flag == "index" && <li><a className="title-nav-down" onClick={() => browserHistory.push({ pathname: `/download` })}>*/}
        {/*<FormattedMessage id='index_download' /></a></li>}*/}
        {/*{flag == "download" && <li><a className="title-nav-down" onClick={() => browserHistory.push({ pathname: `/` })}>*/}
        {/*<FormattedMessage id='main_content_index' /></a></li>}*/}
        <li>
          <a
            onClick={() =>
              dispatch({ type: 'i18n/setLocale', locale: ENGLISH })
            }
          >
            EN
          </a>
        </li>
        <li>
          <a
            onClick={() =>
              dispatch({ type: 'i18n/setLocale', locale: CHINESE_HK })
            }
          >
            繁体中文
          </a>
        </li>
        <li>
          <a
            onClick={() =>
              dispatch({ type: 'i18n/setLocale', locale: CHINESE })
            }
          >
            简体中文
          </a>
        </li>
      </ul>
    </div>
  );
};



// WEBPACK FOOTER //
// ./src/components/login/Header.js